import { useEffect, useState } from "react";
import Srcset from "@/components/common/Srcset";
import { customerOrder, getLineItemStatusByOrderId, getOrderStatus, orderStatusColors, shopifyOrderStatusColors } from "@/helpers/orderHelper";
import { useDispatch, useSelector } from "react-redux";
import { setOrder } from "@/redux/actions/orderAction";
import { useRouter } from "next/compat/router";
import OlivelaLogo from "@/components/common/OlivelaLogo";
import { isDonationProduct } from "@/helpers/pdpHelpers/priceHelpers";
import { getOrderItemStatus } from "functions/utils/orderStatus/getOrderStatus";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import { add3Dots } from "@/helpers/generalHelper";

const OrderDetails = (props) => {
  const router = useRouter();
  const { styles, orderId } = props;
  const [order_status, setOrderStatus] = useState('');
  const [shopify_order_status, setShopifyOrderStatus] = useState('');
  const dispatch = useDispatch();
  const [orderDetails, setOrderDetails] = useState({});
  const [orderLineItemDetails, setOrderLineItemDetails] = useState(null)
  const orders = useSelector((state) => state.order.orders);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const getCustomerOrder = async (id) => {
    const orders = await customerOrder({
      id: id,
    });
    setOrderDetails(orders);
    const lineItemDetails = await getLineItemStatusByOrderId({ id: id });
    setOrderLineItemDetails(lineItemDetails);
  };

  // get the order line items data separately and map it with order details
  useEffect(() => {
    if(orderLineItemDetails){
      const lineItemRemovedAndRefundStatus = (lineItemName) => {
        let isRefunded = false;
        if(orderLineItemDetails?.order?.refunds?.length){
          let refundNodes = orderLineItemDetails?.order?.refunds[0]?.refundLineItems?.nodes
          isRefunded = refundNodes?.find((node) => node?.lineItem?.title === lineItemName) ? true : false
          return {isRefunded : isRefunded}
        }
        else{
          return {isRefunded : false}
        }
      }
      const lineItemDeliveryStatus = (lineItemName) => {
        if (orderLineItemDetails?.order?.fulfillments?.length && !orderLineItemDetails?.order?.refunds?.length) {
          const [deliveryInfoObj] = orderLineItemDetails?.order?.fulfillments?.map((fulfillment) => {
            const { displayStatus, fulfillmentLineItems, deliveredAt } = fulfillment
            const { nodes } = fulfillmentLineItems
            const formattedDate = new Date(deliveredAt)
            const dateOptions = {
              weekday : "long",
              month : "short",
              day : "numeric",
              year : "numeric"
            }
            const formattedDateString = formattedDate.toLocaleDateString(undefined, dateOptions)
            if (nodes.find((elem) => elem?.lineItem?.title === lineItemName && displayStatus === "DELIVERED")) {
              return { isDelivered : true, deliveredAt : formattedDateString }
            }
            else{
              return { isDelivered : false}
            }
          })

          return deliveryInfoObj
        }
        else {
          return
        }
      }
      const appendTrackingInfo = orderLineItemDetails?.order?.lineItems?.nodes?.map((e,i) => ({...e , ...orderLineItemDetails?.order?.fulfillments[i]}))
      const newOrderLineItemsEdges = orderDetails?.lineItems?.edges?.map((elem, idx) => ({node : {...elem.node, ...appendTrackingInfo[idx], ...lineItemRemovedAndRefundStatus(elem.node.title), ...lineItemDeliveryStatus(elem.node.title) }}));

      setOrderDetails({...orderDetails, lineItems : {
        ...orderDetails.lineItems,
        edges : newOrderLineItemsEdges,
      } })

    }
    }, [orderLineItemDetails])

  const getCustomerOrderStatus = async (orderDetails) => {
    let order_status_array = await getOrderStatus(orderDetails);
    setOrderStatus(order_status_array.formattedOrderstatus);
    setShopifyOrderStatus(order_status_array.status);
    setOrderStatus(status)
  };

  useEffect(() => {

    return () => {

      let orderArr = [...orders]
      if (Object.keys(orderDetails).length) {

        orderArr.push(orderDetails)
        dispatch(setOrder(orderArr))
      }
    }
  }, [orderDetails])

  useEffect(() => {

    let findOrder = orders.find(order => order.id === orderId) || {}
    if (Object.keys(findOrder).length) {

      setOrderDetails(findOrder)
    } else {

      getCustomerOrder(orderId);
    }
  }, []);

  useEffect(() => {
    if (orderDetails.fulfillmentStatus)
      getCustomerOrderStatus(orderDetails)
  }, [orderDetails.fulfillmentStatus]);

  if (!orderId) {
    router.push('/account/orders');
    props.activeTab("ordersTab");
    return
  }
  if (!Object.keys(orderDetails).length) {
    return null;
  }

  if (orderDetails.error) {
    router.push('/account/orders');
    props.activeTab("ordersTab");
    return
  }
  var discount = 0
  var discountCode = ''

  if (orderDetails.discountApplications?.edges[0]?.node?.title) {
    discountCode = orderDetails?.discountApplications?.edges[0]?.node?.title
  } else {
    orderDetails?.lineItems?.edges?.forEach((element) => {
      element?.node?.discountAllocations?.forEach((data) => {
        discountCode = data.discountApplication.code
      })
    })
  }
  if (orderDetails.discountApplications?.edges[0]?.node?.value?.amount) {
    discount += orderDetails.discountApplications.edges[0].node.value?.amount
  } else {
    orderDetails.lineItems.edges?.forEach((element) => {
      element.node.discountAllocations.forEach((data) => {
        discount += +data.allocatedAmount?.amount
        discountCode = data.discountApplication.code

      })
    })
  }

  const isEngraved = (lineItem) => {
    let engraveObj = {
      text: "",
      font: "",
    };
    lineItem.node.customAttributes?.forEach((attr) => {
      if (attr?.key === "Free engraving") engraveObj.text = add3Dots(attr?.value,20);
      if (attr?.key === "Engraving font") engraveObj.font = attr?.value;
    });
    return engraveObj;
  };

  return (
    <div className={`${styles.account_card} order_details_card`}>
      <div className={`${styles.account_back} ${isPWA && styles.pwa_account_back}`}>
        <a onClick={() => { props.activeTab("ordersTab") }}>
          <Srcset
            requirePath={true}
            className={'back_icon'}
            svgFile={true}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
            tabIndex={0} 
          />
        </a>
        <Srcset
          onClick={() => { props.setAccountSidebarOpen(false); props.activeTab('') }}
          requirePath={true}
          svgFile={true}
          className={'close_icon_account_tab'}
          src={"images/Icons/Cross/Large.svg"}
          alt="cloe button"
          height="16"
          width="19.11"
        />
      </div>
      <div className={`${styles.card_head}`}>
        <div className={`x-large-xs large-sm x-large-md light ${styles.card_title}`}>
          Order {orderDetails.name?.replace('#', '')}
        </div>
        <div className={`${styles.card_action} small-md xx-small-sm xx-small-xs`}>
          {orderDetails.lineItems.edges?.length} item
          {orderDetails.lineItems.edges?.length !== 1 && "s"}
        </div>

      </div>
      {order_status && <div className={`${styles.card_action} light large-md large-sm small-xs`}>
        {order_status}{
        order_status &&
        <span className="status_rep" style={{backgroundColor:shopifyOrderStatusColors[shopify_order_status.toLocaleLowerCase()] || "#000000"}}></span>
      }
      </div>
      }
     
      <div className={`${styles.card_body}`}>
        <div className={`${styles.product_list}`}>
          {
            orderDetails.lineItems.edges?.map((lineItem, i) => (
              <div
                className={`${styles.product_card}`}
                key={(lineItem.node.variant?.id || 'order_') + i}
              >
                <div className={`${styles.product_card_row}`}>
                  {
                    lineItem?.node?.variant?.product?.handle
                      ? <a tabIndex={-1} href={`/products/${lineItem?.node?.variant?.product?.handle}`} className={`${styles.product_img} ${lineItem.node.variant?.image?.url ? '' : `${styles.no_image}`} ${isDonationProduct(lineItem?.node?.variant?.product) ? styles.disabled : ""}`} onClick={() => { dispatch(showPwaLoader(true)) }}>
                        {
                          lineItem.node.variant?.image?.url
                            ? <img
                              tabIndex={0}
                              src={lineItem.node.variant.image.url}
                              alt={lineItem.node.variant.image?.altText}
                            />
                            : <OlivelaLogo className={styles.olivela_logo} />
                        }
                      </a>
                      : <div className={`${styles.product_img} ${lineItem.node.variant?.image?.url ? '' : `${styles.no_image}`}`}>
                        {
                          lineItem.node.variant?.image?.url
                            ? <img
                              src={lineItem.node.variant?.image.url}
                              alt={lineItem.node.variant?.image.altText}
                            />
                            : <OlivelaLogo className={styles.olivela_logo} />
                        }
                      </div>
                  }
                  <div className={`${styles.product_content}`}>
                    {
                      lineItem?.node?.variant
                        ? <a tabIndex={-1} href={`/products/${lineItem?.node?.variant?.product?.handle}`} className={`${isDonationProduct(lineItem?.node?.variant?.product) ? styles.disabled : ""}`} onClick={() => { dispatch(showPwaLoader(true)) }}>
                          <div tabIndex={0} className={`${styles.product_brand} x-small-xs x-small-sm small-md`}>
                            {lineItem.node.variant.product.vendor}
                          </div>
                          <div tabIndex={0} className={`x-small-xs x-small-sm x-small-md ${styles.product_title}`}>
                            {lineItem.node.title}
                          </div>
                        </a>
                        : <>
                          {
                            lineItem.node.variant
                              ? <div className={`${styles.product_brand} x-small-xs x-small-sm small-md`}>
                                {lineItem.node.variant.product.vendor}
                              </div>
                              : ''
                          }
                          <div className={`x-small-xs x-small-sm small-md ${styles.product_brand}`}>
                            {lineItem.node.title}
                          </div>
                        </>
                    }
                    <div className={`${styles.product_details} x-small-md xx-small-sm xx-small-xs`}>
                      {
                        lineItem.node.variant?.selectedOptions?.map(
                          (option, i) =>
                            `${option.value} ${lineItem.node.variant.selectedOptions.length - 1 !== i
                              ? " | "
                              : ""
                            }`
                        )
                      }
                    </div>
                    {isEngraved(lineItem)?.text && <div className={`${styles.product_details} x-small-md xx-small-sm xx-small-xs`}>
                      Free engraving added: {isEngraved(lineItem)?.text}
                    </div>}
                    {isEngraved(lineItem)?.font && <div className={`${styles.product_details} x-small-md xx-small-sm xx-small-xs`}>
                      Engraving font: {isEngraved(lineItem)?.font}
                    </div>}
                    <div className={`${styles.product_details} x-small-md xx-small-sm xx-small-xs`}>
                      Quantity: {lineItem.node.quantity}
                    </div>
                    {/* <div className={`${styles.product_details} x-small-md xx-small-sm xx-small-xs`}>
                      Order Status: {getOrderItemStatus(lineItem)}
                    </div> */}
                    {/* {
                  lineItem?.node?.trackingInfo?.find(i=>i.url)!=null && <div>
                    <a href={lineItem?.node?.trackingInfo[0]?.url}>Track delivery</a>
                  </div>
                } */}
                    {lineItem.node.discountAllocations.length ? (
                      <div className={`${styles.product_price} small-md x-small-sm x-small-xs`}>
                        $
                        {parseFloat(lineItem.node.originalTotalPrice.amount -
                          lineItem.node.discountAllocations[0].allocatedAmount
                            .amount).toFixed(2)}
                        <del className="xx-small">{lineItem.node.originalTotalPrice.amount}</del>
                      </div>
                    ) : (
                      <div className={`${styles.product_price} small-md x-small-sm x-small-xs`}>
                        {!isDonationProduct(lineItem?.node?.variant?.product) ? "$" + parseFloat(lineItem.node.originalTotalPrice.amount).toFixed(2) : "Free"}
                      </div>
                    )}
                  </div>
                </div>
                
                <div className={`row ${styles.bottom_wrapper}`}>
                <div className="grid-xs-8">
                <div className={`${styles.product_details} ${styles.section} x-small-md xx-small-sm xx-small-xs`}>	
                        Order Status: <span className={`${styles.order_status} x-small-md xx-small-sm xx-small-xs medium`}>{getOrderItemStatus(lineItem)}</span><span className="status_rep" style={{backgroundColor:orderStatusColors[getOrderItemStatus(lineItem).toLocaleLowerCase()] || "#000000"}}></span>
                  </div>
                  {
                    lineItem?.node?.customAttributes.find(i => i?.key === "_estimate") && <div className={`${styles.product_delivery}`}>
                      {lineItem?.node?.customAttributes.find(i => i?.key === "_estimate") ?
                        <><p className={`${styles.section} xx-small-md xx-small-sm xx-small-xs`}>Estimated delivery date:</p>
                          <span className={`${styles.section} xx-small-md xx-small-sm xx-small-xs`}>{lineItem?.node?.customAttributes.find(i => i?.key === "_estimate")?.value?.split("Estimated delivery").pop()}</span>
                        </> : null
                      }
                    </div>
                  }
                    {
                      lineItem?.node?.isDelivered && lineItem?.node?.deliveredAt && <div className={`${styles.product_delivery}`}>
                        <span className={`${styles.section} xx-small-md xx-small-sm xx-small-xs`}>{lineItem?.node?.deliveredAt}</span>
                      </div>
                    }
                </div>
                <div className="grid-xs-4">
                    {
                      lineItem?.node?.trackingInfo?.find(i=>i.url)!=null && <div className={`${styles.tracking_link}`}>
                        <a className="track-delivery" href={lineItem?.node?.trackingInfo[0]?.url} target="_blank" rel="noopener noreferrer">Track delivery<img alt="right-arrow" src={`${process.env.NETLIFY_URL}/icons/Arrow/Right/large.svg?dark`} onClick={() => { dispatch(showPwaLoader(true)) }} /></a>
                      </div>
                    } 
                </div>
                  
                </div>
              </div>


            ))
          }
        </div>
        <div className={`${styles.order_total}`}>
          <table className="table">
            <thead>
              <tr>
                <td className="small-md small-sm x-small-xs">Subtotal</td>
                <td className="small-md small-sm x-small-xs">${parseFloat(orderDetails.currentSubtotalPrice?.amount).toFixed(2)}</td>
              </tr>
              {discount ?
                <tr>
                  <td className="small-md small-sm x-small-xs">Discount {discountCode}</td>
                  <td className="small-md small-sm x-small-xs">-${parseFloat(discount).toFixed(2)}</td>
                </tr>
                : null}
              <tr>
                <td className="small-md small-sm x-small-xs">Shipping</td>
                <td className="small-md small-sm x-small-xs">${parseFloat(orderDetails.totalShippingPriceV2?.amount).toFixed(2)}</td>
              </tr>
              <tr>
                <td className="small-md small-sm x-small-xs">Tax</td>
                <td className="small-md small-sm x-small-xs">${parseFloat(orderDetails.currentTotalTax?.amount).toFixed(2)}</td>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <td className="large-md normal-sm normal-xs light-md">Total</td>
                <td className="small-md normal-sm normal-xs">${parseFloat(orderDetails.currentTotalPrice?.amount).toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        {orderDetails?.shippingAddress && <div className={`${styles.divider}`}></div>}
        {orderDetails?.shippingAddress &&
          <div className={`${styles.order_addresses}`}>
            <div className={`${styles.address_item}`}>
              <h6 className="light-md large-md normal-sm normal-xs">Shipping address</h6>
              <address className="small">
                {orderDetails?.shippingAddress?.firstName.replace('N/A', '')}{' '}{orderDetails?.shippingAddress?.lastName.replace('N/A', '')}
                {(orderDetails?.shippingAddress?.firstName.replace('N/A', '') || orderDetails?.shippingAddress?.lastName.replace('N/A', '')) && <br />}
                {orderDetails?.shippingAddress?.address1}
                {orderDetails?.shippingAddress?.address1 && <br />}
                {orderDetails?.shippingAddress?.address2}
                {orderDetails?.shippingAddress?.address2 && <br />}
                {orderDetails?.shippingAddress?.country},{" "}
                {orderDetails?.shippingAddress?.city}
                {orderDetails?.shippingAddress?.city && <br />}
                {orderDetails?.shippingAddress?.zip}
              </address>
            </div>
            <div className={`${styles.address_item}`}></div>
          </div>
        }
      </div>
      <div className={`${styles.card_footer} button_footer ${isPWA ? styles.card_footer_pwa:""}`}>
        <div className={`${styles.return_cta}`}>
          <a className='btn btn-primary' target="_blank" rel="noopener noreferrer" href={`${process.env.LOOPRETURNS_STORE_DOMAIN}`} onClick={() => { dispatch(showPwaLoader(true)); window?.ReactNativeWebView?.postMessage(JSON.stringify({ externalLink:true, link : `${process.env.LOOPRETURNS_STORE_DOMAIN}`}))}}>Create return or exchange</a>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
